'use strict';

var base = require('base/search/search');
var productBase = require('../product/base');

/**
 * Update DOM elements with Ajax results
 *
 * @param {Object} $results - jQuery DOM element
 * @param {string} selector - DOM element to look up in the $results
 * @return {undefined}
 */
function updateDom($results, selector) {
    var $updates = $results.find(selector);
    $(selector).empty().html($updates.html());
}

/**
 * Update sort option URLs from Ajax response
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
 function updateSortOptions(response) {
    var $tempDom = $('<div>').append($(response));
    var sortOptions = $tempDom.find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        if ($tempDom.find('.grid-footer').data('sort-options').ruleId == option.id) {
            $('option.' + option.id).val(option.url).attr('selected', false);
            $('option.' + option.id).val(option.url).attr('selected', true);
        } else {
            $('option.' + option.id).val(option.url);
        }
    });
}

/**
 * Keep refinement panes expanded/collapsed after Ajax refresh
 *
 * @param {Object} $results - jQuery DOM element
 * @return {undefined}
 */
function handleRefinements($results) {
    $('.refinement.active').each(function () {
        $(this).removeClass('active');
        var activeDiv = $results.find('.' + $(this)[0].className.replace(/ /g, '.'));
        activeDiv.addClass('active');
        activeDiv.find('button.title').attr('aria-expanded', 'true');
    });

    updateDom($results, '.refinements');
}

/**
 * Parse Ajax results and updated select DOM elements
 *
 * @param {string} response - Ajax response HTML code
 * @return {undefined}
 */
function parseResults(response) {
    var $results = $(response);
    var specialHandlers = {
        '.refinements': handleRefinements
    };

    // Update DOM elements that do not require special handling
    [
        '.grid-header',
        '.header-bar',
        '.header.page-title',
        '.product-grid',
        '.show-more',
        '.filter-bar',
        '.results-count'
    ].forEach(function (selector) {
        updateDom($results, selector);
    });

    Object.keys(specialHandlers).forEach(function (selector) {
        specialHandlers[selector]($results);
    });
}

function elementInViewport(el, offsetToTop) {
    var top = el.offsetTop,
        left = el.offsetLeft,
        width = el.offsetWidth,
        height = el.offsetHeight;

    while (el.offsetParent) {
        el = el.offsetParent;
        top += el.offsetTop;
        left += el.offsetLeft;
    }

    if (typeof (offsetToTop) !== 'undefined') {
        top -= offsetToTop;
    }

    if (window.pageXOffset !== null) {
        return (
            top < (window.pageYOffset + window.innerHeight) &&
            left < (window.pageXOffset + window.innerWidth) &&
            (top + height) > window.pageYOffset &&
            (left + width) > window.pageXOffset
        );
    }

    if (document.compatMode === 'CSS1Compat') {
        return (
            top < (window.document.documentElement.scrollTop + window.document.documentElement.clientHeight) &&
            left < (window.document.documentElement.scrollLeft + window.document.documentElement.clientWidth) &&
            (top + height) > window.document.documentElement.scrollTop &&
            (left + width) > window.document.documentElement.scrollLeft
        );
    }
}

//adding callback function of power review
function powerReviews() {
	setTimeout(function () {
        $('body').trigger('pr:event', {
            callback: 'showReviews'
        });
    }, 1000);
}

base.filter = function () {
    // Display refinements bar when Menu icon clicked
    $('.container').on('click', 'button.filter-results', function () {
        $('body').addClass('refinement-bar-open');
        $('.refinement-bar').addClass('animate__animated animate__fadeInUpBig');
        $('.refinement-bar').show();
        $('.refinement-bar').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', true);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', true);
        $('.refinement-bar .close').focus();
    });
};

base.closeRefinements = function () {
    // Refinements close button
    $('.container').on('click', '.refinement-bar button.close, .modal-background', function () {
        $('body').removeClass('refinement-bar-open');
        $('.refinement-bar').hide();
        $('.refinement-bar').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
        $('.btn.filter-results').focus();
    });
};

base.resize = function () {
    // Close refinement bar and hide modal background if user resizes browser
    $(window).resize(function () {
        $('.refinement-bar').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.row').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.tab-pane.active').siblings().attr('aria-hidden', false);
        $('.refinement-bar').closest('.container.search-results').siblings().attr('aria-hidden', false);
    });
};

base.filterHide = function () {
    $(document).on('click', '.filter-section-hide', function () {
        $('body').toggleClass('refinement-bar-closed');
    });
};

base.infiniteScroll = function () {
    if ($('[data-infinite-scroll]').attr('data-infinite-scroll') === 'true') {
        var scrollLoad = true;
        $(window).on('scroll', function () {
        	setTimeout(function () {
	            if ($('.spinner').length === 0) {
	                var loadingPlaceHolder = $('.grid-footer');
	                if (scrollLoad && loadingPlaceHolder.length === 1 && elementInViewport(loadingPlaceHolder.get(0), 250)) {
	                    scrollLoad = false;
	                    $('.show-more button').trigger('click');
	                    setTimeout(function () {
	                        scrollLoad = true;
	                    }, 500);
	                }
	            }
        	}, 1000);
        });
    }
};

base.showMore = function () {
    // Show more products
    $('.container').on('click', '.show-more button', function (e) {
        e.stopPropagation();
        var showMoreUrl = $(this).data('url');
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:showMore', e);
        $.ajax({
            url: showMoreUrl,
            data: { selectedUrl: showMoreUrl },
            method: 'GET',
            success: function (response) {
                $('.grid-footer').replaceWith(response);
                updateSortOptions(response);
                // ---- Start Affirm code section -----
                if (window.resources.preferences.bnplProvider == 'affirm') {
                    affirm.ui.refresh();
                }
                powerReviews();
                // ---- End Affirm code section -----
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

base.applyFilter = function () {
    // Handle refinement value selection and reset click
    $('.container').on(
        'click',
        '.refinements li:not(.disabled) button, .refinement-bar button.reset, .filter-value button, .swatch-filter button, .selected-filter-reset-btn .reset',
        function (e) {
        	var seourl = $(this).data('seourl');
            if ($(this).closest('#refinement-category').length || $(this).closest('#refinement-categories').length) {
                if (seourl) {
                    window.location.href = seourl;
                } else {
                    var dataUrl = window.location.host + $(this).data('href');
                    dataUrl = '//' + dataUrl.replace('Search-ShowAjax', 'Search-Show');
                    window.location.href = dataUrl;
                }
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            $.spinner().start();
            $(this).trigger('search:filter', e);
            var dataHref = $(this).data('href');
            $.ajax({
                url: $(this).data('href'),
                data: {
                    page: $('.grid-footer').data('page-number'),
                    selectedUrl: $(this).data('href')
                },
                method: 'GET',
                success: function (response) {
                    parseResults(response);
                    if (seourl) {
                        history.pushState(undefined, '', seourl);
                    }
                    else {
                    	var dataUrl = window.location.host +  dataHref;
            			dataUrl = '//' + dataUrl.replace('Search-ShowAjax','Search-Show');
            			history.pushState(undefined, '', dataUrl);
                    }
                    // Handle selected filters display section reset button
                    var count = $('.selected-filters-bar').find('ul li').length;
                    if (count > 0) {
                        $('body').addClass('filter-btn-show');
                    } else {
                        $('body').removeClass('filter-btn-show');
                    }
                    $(document).trigger('search:filter:updated');
                    // ---- Start Affirm code section -----
                    if (window.resources.preferences.bnplProvider == 'affirm') {
                        affirm.ui.refresh();
                    }
                    // ---- End Affirm code section -----
                    powerReviews();
                    $.spinner().stop();
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        }
    );
};

base.sort = function () {
    // Handle sort order menu selection
    $('.container').on('change', '[name=sort-order]', function (e) {
        e.preventDefault();

        $.spinner().start();
        $(this).trigger('search:sort', this.value);
        $.ajax({
            url: this.value,
            data: { selectedUrl: this.value },
            method: 'GET',
            success: function (response) {
                $('.product-grid').empty().html(response);
                // ---- Start Affirm code section -----
                if (window.resources.preferences.bnplProvider == 'affirm') {
                    affirm.ui.refresh();
                }
                // ---- End Affirm code section -----
                powerReviews();
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    });
};

base.intiateProductImageSlick = function () {
    $('body').on('shown.bs.modal', '#quickViewModal', function () {
        productBase.quickViewImagesSlick();
        productBase.swatchesHoverImage();
    });
};

base.powerReviews = function (){
	powerReviews();
};

base.defaultSortOption = function () {
    var sortOptions = $('.product-grid').find('.grid-footer').data('sort-options').options;
    sortOptions.forEach(function (option) {
        if ($('.product-grid').find('.grid-footer').data('sort-options').ruleId == option.id) {
            $('option.' + option.id).val(option.url).attr('selected', false);
            $('option.' + option.id).val(option.url).attr('selected', true);
        } else {
            $('option.' + option.id).val(option.url);
        }
    });
}

module.exports = base;
